export const userStoreKey = "session";
export const caregiverStoreKey = "tempSession";

export function getUser() {
  //if tempSession is present, return tempSession, else return session
  const tempSession = getLocalStorage(caregiverStoreKey);
  const mainSession = getLocalStorage(userStoreKey);
  if (tempSession) {
    return { ...tempSession, token: mainSession?.token, is_temp: true }; //
  }
  return mainSession;
}

export function setTempSession(user) {
  setLocalStorage(caregiverStoreKey, user);
}

//clear temp session
export function clearTempSession() {
  removeLocalStorage(caregiverStoreKey);
}

export function getLogedPid() {
  const userData = getLoggedinUser();
  return userData ? userData["pid"] : null;
}

export function getLoggedinUser() {
  return getLocalStorage(userStoreKey);
}

//set, get, remove local storage
export function setLocalStorage(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function getLocalStorage(key) {
  try {
    if (!key) return null;

    const storedValue = localStorage.getItem(key);

    if (
      storedValue &&
      storedValue !== "undefined" &&
      storedValue !== "null" &&
      storedValue !== ""
    ) {
      return JSON.parse(storedValue);
    }

    return null;
  } catch (error) {
    console.log("JSON parse error in getLocalStorage:", error);
    return null;
  }
}

export function removeLocalStorage(key) {
  localStorage.removeItem(key);
}

//clear local storage
export function clearLocalStorage() {
  localStorage.clear();
}

export const setUserInLocalStorage = (user) => {
  localStorage.setItem("user", JSON.stringify(user));
};

export const setCounterInLocalStorage = (counter) => {
  localStorage.setItem("counter", counter.toString());
};

export const getCounterFromLocalStorage = () => {
  const storedCounter = localStorage.getItem("counter");
  return storedCounter ? Number(storedCounter) : 0;
};

export const getUserFromLocalStorage = () => {
  const storedUser = getLoggedinUser();
  return storedUser ? storedUser : null;
};

//logout method
export function logout() {
  clearLocalStorage();
  window.location.href = "/login";
}

//check user allow specific route or not ,on base user key in which is_patient is true or 1
export function isPatient() {
  const user = getUser();
  const keyToCheck = "is_patient";
  //if is_patient key found in user object and is_patient is true or 1, return true, else return false,if not found key then return true
  if (user && keyToCheck in user && user[keyToCheck] !== undefined) {
    return user[keyToCheck];
  } else {
    return true;
  }
}

export function isCaregiver() {
  const user = getLoggedinUser();
  // return user && user.is_caregiver;
  const keyToCheck = "is_caregiver";
  //if is_patient key found in user object and is_patient is true or 1, return true, else return false,if not found key then return true
  if (user && keyToCheck in user && user[keyToCheck] !== undefined) {
    return user[keyToCheck];
  } else {
    return true;
  }
}

export const hasActionRights = (module, action = "view", selectedUser) => {
  const user = selectedUser || getUser();
  const rights = user?.caregiver_rights;
  if (rights) {
    return rights[module] && rights[module][action] == 1 ? hasActionRightsPracticePatient(module,action) : false;
  }
   return hasActionRightsPracticePatient(module,action);
};

export const hasActionRightsPracticePatient = (module = "", functionName = "") => {
   
  const patientPermission = getLocalStorage("patientPermission"); 
  //if access_right key found in user object and access_right is true or 1, return true, else return false,if not found key then return true

  if (patientPermission && patientPermission !== undefined) {
   
    //check module from acces_right key in array with title and check within list that action is access or not
    const access = patientPermission?.find(
      (item) => item.generated_slug?.toLowerCase() === module?.toLowerCase()
    );
    return access?.[functionName]==1 ? 1 : 0;
  } else {
    return true
  }
}

//route permission from user access if user is careGiver,key is access_right
export function isAccessRoute(module = "", functionName = "") {
  const user = getUser();
  const keyToCheck = "access_right";
  //if access_right key found in user object and access_right is true or 1, return true, else return false,if not found key then return true
  if (user && keyToCheck in user && user[keyToCheck] !== undefined) {
    //check module from acces_right key in array with title and check within list that action is access or not
    const access = user[keyToCheck].find((item) => item.title?.toLowerCase() === module?.toLowerCase());
    let flag = access?.list?.find((item2) =>item2.title?.toLowerCase() === functionName?.toLowerCase());
    if (flag) {
      return flag?.allowed == 1 ? true : hasActionRightsPracticePatient(module, functionName);;
    }
    return 0;
  } else {
    return hasActionRightsPracticePatient(module, functionName);
  }
}
